import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-formbuilder',
    templateUrl: './formbuilder.component.html',
    styleUrls: ['./formbuilder.component.scss'],
    standalone: false
})
export class FormbuilderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
